import { useState } from 'react';
import AsyncButton from '@wojtekmaj/react-async-button';
import { useTick } from '@wojtekmaj/react-hooks';
import T from '@wojtekmaj/react-t';
import { ScanBarcodeIcon } from 'lucide-react';

import colors from '@rewardopl/styles/colors';

import Button from '@rewardopl/react-ui/button';

import { post } from '@rewardopl/utils/network';

import { ButtonWrapper, Text, Wrapper } from './email_verification_roadblock.styles';

const COOLDOWN_TIME = 60_000;

function CountToOneMinute() {
  const [startTime] = useState(Date.now());
  const countdownDuration = COOLDOWN_TIME;

  useTick();

  const currentTime = Date.now();

  const elapsedTime = currentTime - startTime;
  const remainingTime = Math.max(countdownDuration - elapsedTime, 0);

  const seconds = Math.floor(remainingTime / 1000);
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const mmss = `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;

  return <T mmss={mmss}>{'Resend in {mmss}'}</T>;
}

const pendingConfig = {
  disabled: true,
};

const successConfig = {
  children: <CountToOneMinute />,
  disabled: true,
};

type EmailVerificationRoadblockProps = {
  showIcon?: boolean;
};

export default function EmailVerificationRoadblock({ showIcon }: EmailVerificationRoadblockProps) {
  async function onClick() {
    const action = `/api/users/current/resend_verification_email`;

    await post(action);
  }

  return (
    <Wrapper>
      {showIcon ? <ScanBarcodeIcon color={colors['secondary-dark']} /> : null}
      <Text>
        <T>To use this feature, please verify your email address.</T>
      </Text>
      <ButtonWrapper>
        <AsyncButton
          as={Button}
          className="primary"
          onClick={onClick}
          pendingConfig={pendingConfig}
          resetTimeout={COOLDOWN_TIME}
          successConfig={successConfig}
        >
          <T>Send verification email</T>
        </AsyncButton>
      </ButtonWrapper>
    </Wrapper>
  );
}
